import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { toPromise } from '@greco-fit/util';
import { Event } from '@greco/booking-events2';
import { UserEventsFavoritesService } from '@greco/ngx-booking-events';
import { UserService } from '@greco/ngx-identity-users';
import { SimpleDialog } from '@greco/ui-simple-dialog';
import { map } from 'rxjs/operators';
import { EventService } from '../../services';

@Component({
  selector: 'alt-event-item',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss'],
})
export class EventItemComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private userSvc: UserService,
    private eventSvc: EventService,
    public favoriteSvc: UserEventsFavoritesService,
    private breakpointObserver: BreakpointObserver
  ) {}

  @HostBinding('class.loading') loading = true;

  @Input() event?: Event;

  isSmallMobile$ = this.breakpointObserver.observe('(max-width: 399px)').pipe(map(result => result.matches));
  isFavorite$ = this.favoriteSvc.favorites$.pipe(map(favorites => favorites.has(this.event?.title || '')));

  removeFavorite() {
    if (!this.event) return;
    this.favoriteSvc.unfavorite(this.event.title);
  }

  addFavorite() {
    if (!this.event) return;
    this.favoriteSvc.addFavorite(this.event.title, {
      title: this.event.title,
      imageUrl: this.event.imageUrl || this.event.calendar?.imageUrl || 'assets/greco/placeholder.png',
      tags: this.event.tags.map(tag => tag.label + ':' + tag.id),
    });
  }

  @HostListener('click') onClick() {
    this.router.navigate(['workouts', this.event?.id]);
  }

  ngOnInit() {
    this.loading = !this.event;
  }

  async joinWaitlist() {
    if (!this.event) return;

    const user = await this.userSvc.getSelf();
    if (!user) return;

    const dialog = this.dialog.open(SimpleDialog, {
      data: {
        showCloseButton: false,
        title: 'Join Waitlist',
        subtitle: 'Are you sure you want to join the waitlist?',
        buttons: [
          { label: 'Cancel', role: 'no' },
          { label: 'Confirm', role: 'yes', color: 'primary' },
        ],
      },
    });

    if ((await toPromise(dialog.afterClosed())) !== 'yes') return;

    const response = await this.eventSvc.joinWaitlistMultiple(this.event?.id, [user.id]);
    if (response?.length) this.event.userStatusInfo = 'waitlisted';
  }
}
